import css from 'styled-jsx/css';

const staticStyles = css`
  .UserContractsPanel {
    position: relative;
    margin: 0 0 20px;
    padding: 25px;
    background: #fff;
    box-shadow: 0 1px 6px 1px rgba(0, 0, 0, 0.06);
  }

  .UserContractsPanel__open-close {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 70px;
    cursor: pointer;

    &--close {
      height: 82px;
    }
  }

  .UserContractsPanel__head {
    display: flex;
    align-items: center;
    margin-bottom: 15px;

    &--hide {
      margin-bottom: 0;
    }
  }

  .UserContractsPanel__arrowTopKYC {
    position: absolute;
    top: 35px;
    right: 20px;
    cursor: pointer;

    &--hide {
      transform: scale(1, -1);
    }
  }

  .UserContractsPanel__content {
    &--hide {
      display: none;
    }
  }

  .UserContractsPanel__contract {
    margin-bottom: 16px;

    &:last-child {
      margin-bottom: 0;
    }

    a {
      color: #16759c;
      font-size: 16px;
      text-decoration: none;

      &:hover {
        text-decoration: underline;
      }
    }

  }

  .UserContractsPanel__empty {
    margin: 0;
    color: #888;
  }

  @media (max-width: 768px) {
    .UserContractsPanel {
      padding: 18px 13px;
    }

    .UserContractsPanel__open-close {
      height: 50px;

      &--close {
        height: 60px;
      }
    }

    .UserContractsPanel__arrowTopKYC {
      top: 25px;
    }
  }
`;

export { staticStyles };
